/* SEW Markaz — keeps the savings line correct across variant changes.

   Dawn re-renders the price block when a variant changes, but it does not
   re-render custom blocks. So the line is recalculated here from a price map
   emitted by the Liquid, keyed on the hidden variant input the product form
   already maintains. */

(function () {
  function money(cents) {
    var rupees = Math.round(cents / 100);
    return 'Rs.' + rupees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init() {
    var box = document.querySelector('[data-sew-savings]');
    var dataEl = document.querySelector('[data-sew-variant-prices]');
    var form = document.querySelector('.product-form form, product-form form');
    if (!box || !dataEl || !form) return;

    var prices;
    try {
      prices = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function update() {
      var input = form.querySelector('[name="id"]');
      if (!input) return;
      var v = prices[input.value];
      if (!v || !v.compare || v.compare <= v.price) {
        box.hidden = true;
        return;
      }
      var diff = v.compare - v.price;
      var pct = Math.round((diff * 100) / v.compare);
      box.textContent = 'You save ' + money(diff) + ' (' + pct + '%)';
      box.hidden = false;
    }

    if ('MutationObserver' in window) {
      new MutationObserver(update).observe(form, {
        subtree: true,
        attributes: true,
        attributeFilter: ['value'],
        childList: true
      });
    }
    form.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
